<div class="ql-snow">
  <div style="padding-left: 2px;font-size:0.7rem;font-family: Calibri, sans-serif !important;line-height: 2;" class="ql-editor">
    <p id="helpText"></p>
  </div>
</div>

